export function appendToDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: appendToDirectiveCtrl,
	};
}

export class appendToDirectiveCtrl {
	constructor($element, $attrs, $timeout) {
		'ngInject';
		const append = () => {
			setTimeout(() => {
				const el = document.querySelector($attrs.shAppendTo);
				if (el) {
					el.appendChild($element[0]);
				}
			}, 0);
		};
		$attrs.$observe('shAppendTo', append);
	}
}
